import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TableService, TableResponseModel, ITableState } from '../../_metronic/shared/crud-table';
import { Profile } from '../_models/profile.model';
import { baseFilter } from '../../_fake/fake-helpers/http-extenstions';
import { first } from 'rxjs/operators';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { UserModel} from '../../modules/auth/_models/user.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends TableService<Profile> implements OnDestroy {
  apiUrls = {
    getProfile  : `${environment.url}/${environment.apiUrl}/Producer/get_asegurado_insured?`,
    getProfile2 : `${environment.url}/${environment.apiUrl}/Entidad/get_user_info?`,
    postProfile : `${environment.url}/${environment.apiUrl}/Entidad/post_actualizar_datos_asegurado?`,
  }
  constructor(@Inject(HttpClient) http, private auth: AuthService) {
    super(http);
  }

   
  find(tableState: ITableState): Observable<TableResponseModel<Profile>> {
    return this.http.get<Profile[]>(this.apiUrls.getProfile2 + tableState.paramsGet, {headers: this.auth.httpHeaders}).pipe(
      map((response: Profile[]) => {
        const filteredResult = baseFilter(response, tableState);
        const result: TableResponseModel<Profile> = {
          items: filteredResult.items,
          total: filteredResult.total
        };
        return result;
      })
    );
  }

  // READ
  async getProfile(paramsGet: string = "") {
    return await this.http.get<Profile>(this.apiUrls.getProfile2 + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async postProfile(profile: any) {
    var data = new FormData();
    data.append("data", JSON.stringify([profile]));
    return await this.http.post<UserModel>(this.apiUrls.postProfile, data, {headers: this.auth.httpHeaders}).toPromise();
  }

  extracData(id, policies) {
    var item;

    //FEXME
    policies.pipe().subscribe(items => {
      return items.filter(c => {
        if(c.IdPoliza == id) {
          return (item = c);
        }
      });
    });
        
    return item;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }
}
